import styled from 'styled-components'

export const Wrapper = styled.div`
  width: 100%;
  height: auto;
  .create {
    margin-left: 30px;
    background-color: ${({ theme }) => theme.colors.secondPrimary};
    @media (max-width: ${({ theme }) => theme.responsive.ipad}) {
      margin-top: 40px;
    }
  }
  @media (max-width: ${({ theme }) => theme.responsive.ipad}) {
    width: 100%;
  }

  .center {
    text-align: center;
    justify-content: center;
    display: flex;
    align-items: center;
  }
  .no_investment_lg {
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    height: 350px;
    @media (max-width: ${({ theme }) => theme.responsive.ipad}) {
      display: none;
    }
  }
`

export const Container = styled.div<{
  width?: any
}>`
  width: 100%;
  height: auto;
  background-color: red;
  /* margin: 4rem 0; */
  background-color: ${({ theme }) => theme.colors.white};
  padding: 30px;
  @media (max-width: ${({ theme }) => theme.responsive.mobile}) {
    margin: 0;
  }

  .heading {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 10px 0px 20px 0px;
    @media (max-width: ${({ theme }) => theme.responsive.mobile}) {
      width: 88vw;
    }
    h2 {
      font-family: ${({ theme }) => theme.fontFamily.visuelt};
      font-style: Medium;
      font-size: ${({ theme }) => theme.fontSize.xx3};
      letter-spacing: 0.75%;
      color: ${({ theme }) => theme.colors.CollaboBlue};

      @media (max-width: ${({ theme }) => theme.responsive.mobile}) {
        margin-right: 15px;
        font-size: ${({ theme }) => theme.fontSize.x6};
      }
    }

    @media (max-width: ${({ theme }) => theme.responsive.laptop}) {
    }
  }
  .plans {
    display: flex;
    align-items: center;
    width: auto;
    margin-bottom: 30px;
    background-color: #f8f9fe;
    padding: 20px;
    border-radius: 10px;
    @media (max-width: ${({ theme }) => theme.responsive.mobile}) {
      padding: 10px;
      margin-top: 10px;
    }

    .circle {
      height: 55px;
      width: 55px;
      border-radius: 50%;
      background-color: #c4c4c4;
    }
    .info {
      padding-left: 30px;
      width: 70%;
    }
    .description {
      font-family: ${({ theme }) => theme.fontFamily.inter};
      font-style: bold;
      font-size: ${({ theme }) => theme.fontSize.x1};
      letter-spacing: 0.75%;
      color: ${({ theme }) => theme.colors.activeBlue};
      @media (max-width: ${({ theme }) => theme.responsive.mobile}) {
        font-size: ${({ theme }) => theme.fontSize.x2};
      }
    }
    .amount {
      font-family: ${({ theme }) => theme.fontFamily.inter};
      font-style: normal;
      font-size: ${({ theme }) => theme.fontSize.x5};
      letter-spacing: 0.75%;
      color: #64e200;
      @media (max-width: ${({ theme }) => theme.responsive.mobile}) {
        margin-top: -10px;
        font-size: ${({ theme }) => theme.fontSize.s};
      }
    }
    .slider {
      width: 100%;
      border-radius: 11.87px;
      opacity: 30%;
      mix-blend-mode: normal;
      display: flex;
      align-items: center;
      height: 5px;
      background-color: ${({ theme }) => theme.colors.gray};
    }
  }
`
